export const convertLetterToNumber = (str: string) => {
    str = str.toUpperCase();
    let out = 0;
    const len = str.length;
    for (let pos = 0; pos < len; pos++) {
        out += (str.charCodeAt(pos) - 64) * Math.pow(26, len - pos - 1);
    }
    return Number(out);
};
